// 박 표시 줄바꿈 규칙
//  1) 한 줄에 들어가면 한 줄
//  2) 넘치면 묶음 단위로만 줄을 바꾸고(묶음을 쪼개지 않음), 줄마다 박 수가 고르게 나뉘게 한다
//  3) 모든 줄의 칸 폭을 같게 맞춘다 (세로 정렬)
export const BEAT_LAYOUT = { cellMin: 26, cellMax: 44, innerGap: 3, groupPad: 6, groupGap: 8 };

export function rowWidth(row, cell, opts = BEAT_LAYOUT) {
  const groups = row.reduce((w, g) => w + g * cell + (g - 1) * opts.innerGap + opts.groupPad, 0);
  return groups + (row.length - 1) * opts.groupGap;
}

// 묶음 배열을 n줄로 연속 분할 — 가장 긴 줄의 박 수가 최소가 되게 (동률이면 앞줄을 길게)
function balancedSplit(groups, n) {
  const G = groups.length;
  const prefix = [0];
  groups.forEach((g) => prefix.push(prefix[prefix.length - 1] + g));
  const span = (i, j) => prefix[j] - prefix[i];
  // best[k][i]: 앞 i개 묶음을 k줄로 나눌 때 최장 줄 길이의 최솟값
  const best = Array.from({ length: n + 1 }, () => Array(G + 1).fill(Infinity));
  const cut = Array.from({ length: n + 1 }, () => Array(G + 1).fill(0));
  best[0][0] = 0;
  for (let k = 1; k <= n; k++) {
    for (let i = k; i <= G; i++) {
      for (let j = k - 1; j < i; j++) {
        const v = Math.max(best[k - 1][j], span(j, i));
        if (v < best[k][i] || (v === best[k][i] && j > cut[k][i])) {
          best[k][i] = v;
          cut[k][i] = j;
        }
      }
    }
  }
  const rows = [];
  let i = G;
  for (let k = n; k > 0; k--) {
    const j = cut[k][i];
    rows.unshift(groups.slice(j, i));
    i = j;
  }
  return rows;
}

// → { rows: [[묶음 크기...], ...], cell: 칸 폭(px) }
export function layoutBeats(groups, availableWidth, opts = BEAT_LAYOUT) {
  let rows = null;
  for (let n = 1; n <= groups.length; n++) {
    const candidate = balancedSplit(groups, n);
    if (candidate.every((r) => rowWidth(r, opts.cellMin, opts) <= availableWidth)) {
      rows = candidate;
      break;
    }
  }
  if (!rows) rows = groups.map((g) => [g]);
  const fits = (c) => rows.every((r) => rowWidth(r, c, opts) <= availableWidth);
  let cell = opts.cellMax;
  while (cell > opts.cellMin && !fits(cell)) cell -= 1;
  return { rows, cell };
}
